<template>
<div class="mt_140">

    <ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
    <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

    <div class="container">
    <div class="row">
    <div class="col-md-12">

      <!-- row -->
      <div class="row">

        <!-- coluna 2 -->
        <div class="col-md-2">
          <ccMenuConta :num=1></ccMenuConta>
        </div">
        <!-- fim coluna 2 -->       

        <!-- coluna 10 -->
        <div class="col-md-10" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

            <div class="row">
              <div class="col-md-12 p-5">

                  <div class="row">
                    <div class="col-md-6">
                          <div class="text_branco text_bold text_18 mb-2"> Bem Vindo: {{user.username}} </div>
                          <div class="text_branco text_bold text_13 mb-2">SALDO TOTAL: <span class="text_22 text_laranja">
                            R${{formatarMoeda(parseFloat(user.balance)+parseFloat(user.balance_convidado))}}</span>
                          </div>
                          <div class="text_branco text_bold text_13 mb-1">SALDO PRINCIPAL: <span class="text_cinza">R${{ formatarMoeda(parseFloat(user.balance)) }}</span></div>
                          <div class="text_branco text_bold text_13 mb-1">SALDO CONVIDADO: <span class="text_cinza">R${{ formatarMoeda(parseFloat(user.balance_convidado))}}</span></div>
                          <div class="text_branco text_13 text_bold">SENHA DA CONTA: <router-link to="/esqueceu/senha" class="text_verde text_bold">Editar</router-link>  </div>
                    </div>
                    <div class="col-md-6">
                        <div class="text_branco text_13 text_bold mb-3"> ID DA CONTA:  <span class="text_cinza">{{user.id}}</span> </div>
                        <div class="text_branco text_13 text_bold mb-3"> CPF DA CONTA:
                          <span v-if="user.cpf == null">
                            <b style="color:red;"> NÃO CADASTRADO,</b>
                            <b style="color:#5cb70d;">
                              <router-link to="/conta/dados" class="text_verde"> CADASTRE AGORA </router-link> </b>
                          </span>
                          <span v-else class="text_cinza text_12"> {{user.cpf}} </span>
                        </div>

                        <button v-if="user.conta_check_verificada==0" class="btn btn-outline-warning btn-sm w-100 text_12 p-2">CONTA NÃO VERIFICADA</button>
                        <button v-if="user.conta_check_verificada==1" type="button" class="btn btn-outline-success btn-sm w-100 text_12 p-2">CONTA VERIFICADA</button>
                        <button v-if="user.conta_check_verificada==2" class="btn btn-outline-danger btn-sm w-100 text_12 p-2">CONTA REPROVADA</button>
                    </div>
                  </div>

              </div>
            </div>

            <div class="row mb-4">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">
                      <div class="text_branco text_13 text_bold mb-2"><b>ENDEREÇO DA CONTA</b> </div>
                      <div class="text_12" v-if="user.rua == null || user.rua == 'null' || user.bairro == null || user.bairro == 'null' || user.estado_id == 0 ">
                        <div class="text_12 text_cinza mb-2">Nenhum Endereço Cadastrado:</div>
                        <router-link to="/conta/dados" class="text_verde text_bold"> Finalize o seu cadastro </router-link>
                      </div>
                      <div v-else>
                        <div class="text_cinza mb-2">
                          <b>Rua:</b> {{user.rua}}<br>
                          <b>Bairro:</b> {{user.bairro}}<br>
                          <b>Estado:</b> {{user.estado_nome}}
                        </div>
                          <router-link to="/conta/dados" class="text_12 text_verde text_bold"> Editar </router-link>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="card">
                    <div class="card-body">

                      <div class="text_branco text_13 text_bold mb-2"><b>INFORMAÇÕES PESSOAIS</b> </div>
                      <div class="text_12" v-if="user.nome_first == null || user.nome_last == null">
                        <div class="text_12 text_cinza mb-2">Nenhum Cadastrado:</div>
                        <router-link to="/conta/dados" class="text_verde text_bold"> Finalize o seu cadastro </router-link>
                      </div>
                      <div v-else>
                        <div class="text_cinza mb-2">
                          <b>Primeiro Nome:</b> {{user.nome_first}}<br>
                          <b>Último Nome:</b> {{user.nome_last}}<br>
                          <b>Nascimento:</b> {{dateBR2(user.nascimento)}}<br>
                          <b>Telefone:</b> {{user.telefone}}
                        </div>
                        <router-link to="/conta/dados" class="text_12 text_verde text_bold"> Editar </router-link>
                      </div>

                    </div>
                  </div>
                </div>
            </div>

            <div class="row">
              <div class="col-md-12 p-5">

                  <div class="text_branco text_13 text_bold mb-2"><b>CONVIDAR E GANHAR</b> </div>
                    <router-link to="/conta/convite/resumo" class="text_12 text_verde text_bold"> Compartilhe seu link e começe a lucrar </router-link>
                  </div>

              </div>

        </div>
        <!-- fim coluna 10 -->

      </div>
      <!-- fim row -->

    </div>
    </div>
    </div>

    <ccFooter></ccFooter>

</div>
</template>

<script>

import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccFooter from '../layout/footer.vue'
import { RouterLink } from 'vue-router';

export default {
  data () {
    return {
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],
    }
  },

  components: { ccMenu, ccFooter, ccMenuConta, ccLoading, RouterLink },

  created(){
    document.title = 'Minha Conta: Resumo - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)
    this.frm_torneio_tipo = this.$route.params.tipo_id
  },

  mounted()
  {
    let a = JSON.parse(localStorage.getItem("user"));

    if (a == null){
      this.user = {}
    }else{
      this.user = a
    }

    this.get_user_completo()
  },

  methods: {

    get_user_completo(){
      this.loading = true;
      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.get(this.base_url_api+'user/completo', header)
      .then(response => {
        this.user = response.data.resp
        this.loading = false;

        //atualize balance no menu
        this.$refs.cc_menu.get_user();
      })
      .catch(e => {
        this.errors.push(e);
        this.expluse_para_login()
      });
    },

    sair(){
      alert('deseja realmente sair?')
      this.user = {}
      localStorage.removeItem("user")
      this.user_logado = false
    },

  }

}
</script>

<style scoped>

  .card{
    background: #FFFFFF08 0% 0% no-repeat padding-box;
    color:#fff;
  }

</style>


// WEBPACK FOOTER //
// src/components/conta/resumo.vue